import { render, staticRenderFns } from "./TenantAuthSettings.vue?vue&type=template&id=d9f38edc"
import script from "./TenantAuthSettings.vue?vue&type=script&lang=ts"
export * from "./TenantAuthSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports